import React from 'react';
import { useIsMobile } from '@/hooks/use-mobile';
import { AppShell } from '@/components/layout/AppShell';
import { BottomNavigation } from './BottomNavigation';
import { MobileHeader } from './MobileHeader';
import { PWAInstallPrompt } from './PWAInstallPrompt';

interface MobileAppShellProps {
  children: React.ReactNode;
}

export const MobileAppShell = ({ children }: MobileAppShellProps) => {
  const isMobile = useIsMobile();

  if (!isMobile) {
    return <AppShell>{children}</AppShell>;
  }

  return (
    <div className="min-h-screen bg-background flex flex-col">
      <MobileHeader />
      <main className="flex-1 pb-16 overflow-auto">
        {children}
      </main>
      <BottomNavigation />
      <PWAInstallPrompt />
    </div>
  );
};